import { useSyncExternalStore } from "react";

const STORAGE_KEY = "volca-dev-bar";

const listeners = new Set<() => void>();

const readVisible = () => {
  try {
    return localStorage.getItem(STORAGE_KEY) !== "hidden";
  } catch {
    return true;
  }
};

export const devBarPreference = {
  get: readVisible,
  set: (visible: boolean) => {
    try {
      localStorage.setItem(STORAGE_KEY, visible ? "visible" : "hidden");
    } catch {
      // Private mode can refuse storage. The bar still toggles for this call.
    }
    listeners.forEach((listener) => listener());
  },
  subscribe: (listener: () => void) => {
    listeners.add(listener);
    return () => listeners.delete(listener);
  },
};

export const useDevBarVisible = () =>
  useSyncExternalStore(
    devBarPreference.subscribe,
    devBarPreference.get,
    () => true,
  );
